import { useQuery } from '@tanstack/react-query';
import * as Effect from 'effect/Effect';
import { pipe } from 'effect/Function';
import { ApiClient } from '@/api/client';
import { MainLayer } from '@/effects/layers';
import { runEffect } from '@/effects/runtime';
import { ListRecurringExpensesResponseSchema } from '@/api/schemas/recurring.schema';

export const RECURRING_EXPENSES_QUERY_KEY = 'recurring-expenses';

export function useRecurringExpenses(groupId: string) {
  return useQuery({
    queryKey: [RECURRING_EXPENSES_QUERY_KEY, groupId],
    queryFn: async () => {
      const program = pipe(
        Effect.gen(function* () {
          const apiClient = yield* ApiClient;
          return yield* apiClient.get(
            `/groups/${groupId}/recurring-expenses`,
            ListRecurringExpensesResponseSchema
          );
        }),
        Effect.provide(MainLayer)
      );
      const result = await runEffect(program);
      return result.recurring_expenses;
    },
    enabled: !!groupId,
    staleTime: 60 * 1000,
    networkMode: 'always',
  });
}
